var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColseparator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 60,
    viewBox: "0 0 2 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V60",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColseparator);
export default __webpack_public_path__ + "static/media/colseparator.98e0082fb67cf12f19b991da9a350912.svg";
export { ForwardRef as ReactComponent };